import { FAVORITES_LIST_KEY } from 'favorite/constants/constants'
import type { FavoriteProductResponse } from 'favorite/types/types'
import { getFavoritesStorage } from 'favorite/utils/favoritesCache'

export const getCacheFavorites = (logged = false) =>
	getFavoritesStorage(logged)?.getKeyFromCache<FavoriteProductResponse[]>(
		FAVORITES_LIST_KEY
	)
